import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Message } from '../app.models';
import { HostService } from './host.service';

@Injectable({
  providedIn: 'root'
})
export class MessageService {

  constructor(private getHost: HostService, private http: HttpClient) { }

  /**
   * Cette methode afficher tous les reservations/locations concernant un utilisateur
   * @param idUser 
   * @returns 
   */
  listOfChat(idUser: number, key: string) {

    return this.http.get(this.getHost.gethttps() + "listOfChat/" + idUser+'/'+key);

  }

  /**
   * Cette permet de recuperer tous les messages d'une reservation/location
   * @param idRenting 
   * @returns 
   */
  fetchMessage(idRenting: number) {
    
    return this.http.get(this.getHost.gethttps() + "fetchMessage/" + idRenting);

  }

  sendMessage(message: Message) {

    return this.http.post(this.getHost.gethttps() + "sendMessage", message);

  }

  /**
   * Cette methode retourné tous les messages non lu de l'utilisateur
   * 
   * @param idUser 
   * @returns 
   */
  fetchAllUnreadMessagesOfUser(idUser: number) {
    
    return this.http.get(this.getHost.gethttps() + "fetchAllUnreadMessagesOfUser/" + idUser);

  }

}
